import Mutations from './mutations.js';
import Getters from './getters.js';
import Actions from './actions.js';
import data from '@/assets/data/CrimeData.js';
import data2 from '@/assets/data/AllCrimesData.js';


export default {
    state(){
        return {
            CrimeData :  data.CrimeData,
            AllCrimesData: data2.AllCrimesData,
            topTenCriminals:[],
            topTenCrimes:[],
            topTenSentences:[],
            criminalsSoap:'All Soaps',
            crimesSoap:'All Soaps',
            sentencesSoap:'All Soaps',
            isShowCrimeDetails:true,
            isShowSentenceDetails:true,
        }
    },
    mutations: Mutations,
    getters: Getters,
    actions: Actions
}